import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		isCol: false
	},
	getters: {
		colStatus (state) {
			return state.isCol;
		}
	},
	actions: {
		//使用this.$store.dispatch(函数名,携带的值)
		doActionCol (context) {
			context.commit('setCol');
		}
	},
	mutations: {
		//使用this.$store.commit(函数名,携带的值)
		setCol (state) {
			state.isCol = !state.isCol;
		}
	}
})



// WEBPACK FOOTER //
// ./src/store/index.js